<script>
import BillingSettings from './BillingSettings'

export default {
  name: 'BillingSettingsDisplay',
  extends: BillingSettings,
  computed: {
    warehouseLimitedInfo () {
      return this.selectedWarehouseLimitedInfo
    },
    rates () {
      return this.warehouseLimitedInfo.rates || {}
    },
    unitRates () {
      return this.rates.unitRates || []
    },
    forecastUnitRates () {
      return this.rates.forecastUnitRates || {}
    }
  },    
  props: {
    selectedWarehouseLimitedInfo: Object
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BillingSettingsDisplay.vue